import { useMemo } from 'react';

const evaluateCondition = (condition, formData) => {
  if (!condition) return true;

  const currentValue = formData[condition.fieldId] || '';
  const { operator, value } = condition;

  switch (operator) {
    case 'equals':
      return currentValue === value;
    case 'notEquals':
      return currentValue !== value;
    case 'in':
      return Array.isArray(value) && value.includes(currentValue);
    case 'notEmpty':
      return currentValue !== '' && currentValue !== null && currentValue !== undefined;
    case 'isEmpty':
      return currentValue === '' || currentValue === null || currentValue === undefined;
    default:
      return true;
  }
};

export const useFieldVisibility = (formStructure, formData) => {
  return useMemo(() => {
    const visible = new Set();

    if (!formStructure?.sections) return visible;

    for (const section of formStructure.sections) {
      for (const field of section.fields) {
        if (evaluateCondition(field.condition, formData)) {
          visible.add(field.id);
        }
      }
    }

    return visible;
  }, [formStructure, formData]);
};
